export const getRoomAndUserId = (from?: string) => {
  const [roomIdAndDomain, userAndDomain] = from?.split('/') ?? [undefined, undefined]
  const roomId = roomIdAndDomain?.split('@')[0]
  const userId = userAndDomain?.split('@')[0]
  return { roomId, userId }
}
